define('paychex.app.messages/app',[
    'angular',
    'htmlregistry',
    'lib.angular-material',
    'paychex.framework.angular.localization/module',
    'paychex.app.messages/services/module',
    'paychex.app.messages/panel/module',
    'paychex.app.messages/icon/module',
    'paychex.app.messages/drawer/module',
    'paychex.app.messages/messages-templates'
], function MessagesAppModule(
    angular,
    htmlregistry,
    ngMaterial,
    localization,
    services,
    panel,
    icon,
    drawers,
    templates
) {
    'use strict';

    return angular.module('paychex.app.messages', [
        'ngMaterial',
        localization.name,
        services.name,
        panel.name,
        icon.name,
        drawers.name
    ])
        .run(templates)
        .run(['LocaleService', function setUpTranslations(LocaleService) {
            LocaleService.addAvailableLocales(['en', 'es']);
            LocaleService.addTranslationPath(htmlregistry.paths['paychex.app.messages'] + '/localization/translations/{localeId}.js');
        }]);

});

